import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  booleanAttribute,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'procure-hint',
  templateUrl: './hint.component.html',
  styleUrl: './hint.component.scss',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class Hint {
  @Input() type: 'hint' | 'error' | 'warning' = 'hint';
  @Input({ transform: booleanAttribute }) standalone: boolean = false;
}
